import './section.scss'
import React from 'react'
import ReactDOM from 'react-dom'
import asyncComponent from 'lib/react/async_component'
import SectionProps from '../props/section'
import BaseStructure from '../base'
import {simpleFormat} from "lib/util"

const VideoPlayer = asyncComponent(() => import('lib/react/video-player').then(module => module.default))

// 版块结构
export class SectionStructure extends BaseStructure {
  static CATALOGS = [
    {name: '头条', type: 'welcome'},
    {name: '相册&画报', type: 'gallery'},
    {name: '选项卡', type: 'tabs'},
    {name: '图文列表', type: 'features'},
    {name: '轮播', type: 'carousel'},
    {name: '合作伙伴', type: 'partners'},
    {name: '团队', type: 'team_members'},
    {name: '新闻&动态', type: 'news'},
    {name: '价格方案', type: 'pricing'},
    {name: '客户说', type: 'says'},
    {name: '列表', type: 'collection'},
  ]

  static formatStateContent(state) {
    const list = (state.list || []).map(item => {
      if (!item.description) return item
      const description = Object.assign({}, item.description, {
        content: simpleFormat(item.description.content)
      })
      return Object.assign({}, item, {description: description})
    })
    //
    let paragraph = state.paragraph
    if (paragraph) {
      paragraph = Object.assign({}, state.paragraph, {
        content: simpleFormat((state.paragraph || {}).content)
      })
    }
    //
    return Object.assign({}, state, {
      paragraph: paragraph,
      list: list
    })
  }

  constructor(props) {
    super(SectionStructure.formatStateContent(props))
    this.customize = this.props.customize
    this.sectionProps = Object.assign({}, SectionProps.props(this.props), {
      site: props.site,
      openVideoPlayer: this.openVideoPlayer,
      closeVideoPlayer: this.closeVideoPlayer
    })
    this.sectionType = this.props.preset.split('-')[0]
  }

  static getPresetsByType(type, sectionState) {
    sectionState.preset = type
    const structure = new SectionStructure(sectionState)
    return structure.presets()
  }

  presets() {
    const Section = require(`./${this.sectionType}/index`)
    const props = {
      customizeClassName: this.customizeClassName(),
      customizeStyles: this.customizeDesignStyles(),
    }
    //
    return Section.default(Object.assign({}, this.sectionProps, props))
  }

  formatSectionHtml(html) {
    return (
      <div className={"site-section" + this.customizeClassName()}
           style={this.customizeDesignStyles()}>
        {html}
      </div>
    )
  }

  // 根据 id 查找不同类型的版块布局数据
  current() {
    let preset = this.presets().find(item => item.uid === this.props.preset)
    preset.html = this.formatSectionHtml(preset.html)
    return preset
  }

  openVideoPlayer = (src) => {
    if ($('#video-player-wrap').length === 0) {
      $('body').append('<div id="video-player-wrap"></div>')
    }
    ReactDOM.render(
      <VideoPlayer
        src={src}
        close={this.closeVideoPlayer}
        parentSelector="#video-player-wrap"
      />,
      document.querySelector('#video-player-wrap')
    )
  }

  closeVideoPlayer = () => {
    $('#video-player-wrap').remove()
  }
}

export default SectionStructure


// WEBPACK FOOTER //
// ./app/javascript/app/site/structures/section/index.js